module.exports = __webpack_public_path__ + "img/bg.43e5602f.png";